module.exports = __webpack_public_path__ + "static/1-573bc2de97f8b6187674b757eddb5062.jpeg";